"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinText = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _defineType = require("../../_util/defineType");
var _utils = require("../../_util/utils");
var _jsxRuntime = require("react/jsx-runtime");
const SpinText = _ref => {
  let {
    type = 'primary',
    spining = true,
    children,
    className,
    style,
    ...restProps
  } = _ref;
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...attrs.data,
    className: (0, _classnames.default)('spin-text', "spin-text-type-".concat(type), className),
    style: style,
    children: [spining && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
      className: "spin-text-spining"
    }), !(0, _defineType.isNone)(children) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: children
    })]
  });
};
exports.SpinText = SpinText;